import { render, staticRenderFns } from "./CalendarPreviewBlock.vue?vue&type=template&id=50f282db&scoped=true&"
import script from "./CalendarPreviewBlock.vue?vue&type=script&lang=js&"
export * from "./CalendarPreviewBlock.vue?vue&type=script&lang=js&"
import style0 from "./CalendarPreviewBlock.vue?vue&type=style&index=0&id=50f282db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f282db",
  null
  
)

export default component.exports